export class UpdateFeeReceiptStatus {
  fr_Sessionid: number;
  fr_frid: number;
  fr_chqbounced: boolean;
  fr_chqcleared: boolean;
  fr_active: boolean;
  fr_rmrks: string;
  }

